import { ServiceReviewsRepository } from "../../domain/repositories/serviceReviewsRepository"
import { ServiceReview, ServiceReviewUpdate } from "../../domain/entities/ServiceReview"
import { CreateServiceReviewParams } from "../../domain/useCases/serviceReviews/createServiceReview"
import { ServiceReviewsService } from "../services/ServiceReviewsService"

export class ServiceReviewsRepositoryImpl implements ServiceReviewsRepository {
	private _serviceReviewsService: ServiceReviewsService

	constructor({ ServiceReviewsService }: { ServiceReviewsService: ServiceReviewsService }) {
		this._serviceReviewsService = ServiceReviewsService
	}

	async getServiceReviews(serviceId: number, pagination?: number, limit?: number): Promise<ServiceReview[]> {
		return await this._serviceReviewsService.getServiceReviews(serviceId, pagination, limit)
	}

	async createServiceReview(params: CreateServiceReviewParams): Promise<ServiceReview> {
		return await this._serviceReviewsService.createServiceReview(params)
	}

	async updateServiceReview(reviewUpdate: ServiceReviewUpdate): Promise<void> {
		return await this._serviceReviewsService.updateServiceReview(reviewUpdate)
	}

	async deleteServiceReview(reviewId: number): Promise<void> {
		return await this._serviceReviewsService.deleteServiceReview(reviewId)
	}
}
